import { t } from 'i18next'
import { MenuItem } from 'primereact/menuitem'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const UserManagementPage = lazy(() => import('../containers/UserManagement/UserManagementContainer'))
const UserProfilePage = lazy(() => import('../containers/UserManagement/UserProfile/UserProfileContainer'))
const AuthorizationsGroupsPage = lazy(() => import('../containers/UserManagement/AuthorizationsGroups/AuthorizationsGroupsContainer'))

export const USER_MANAGEMENT_PATHS = {
  HOME: '/user-management',
  AUTHORIZATIONS_GROUPS: '/user-management/authorizations-groups',
  PROFILE: (userId?: string) => `/user-management/${userId ? userId : ':userId'}`
} as const

export const userManagementRoutes: RouteObject[] = [
  {
    path: USER_MANAGEMENT_PATHS.HOME,
    children: [
      {
        index: true,
        element: <UserManagementPage />,
        handle: {
          crumb: (): MenuItem[] => [
            { label: t('general:menu.user_management') || '', url: USER_MANAGEMENT_PATHS.HOME },
          ],
        },
      },
      {
        path: USER_MANAGEMENT_PATHS.PROFILE(),
        element: <UserProfilePage />,
        handle: {
          crumb: (params: Record<string, string>): MenuItem[] => [
            { label: t('general:menu.user_management') || '', url: USER_MANAGEMENT_PATHS.HOME },
            { label: t('general:menu.user_profile') || '', url: USER_MANAGEMENT_PATHS.PROFILE(params.userId) },
          ],
        },
      },
      {
        path: USER_MANAGEMENT_PATHS.AUTHORIZATIONS_GROUPS,
        element: <AuthorizationsGroupsPage />,
        handle: {
          crumb: (params: Record<string, string>): MenuItem[] => [
            { label: t('general:menu.user_management') || '', url: USER_MANAGEMENT_PATHS.HOME },
            { label: t('general:menu.authorizations_group') || '', url: USER_MANAGEMENT_PATHS.AUTHORIZATIONS_GROUPS },
          ],
        },
      },
    ],
  },
]
